/**
 * Update Responsive Property Utility
 *
 * Utility function for updating a single property for a specific breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { ResponsiveAttributes, ResponsiveBreakpoint } from '../../types';
import { updateResponsiveValues } from '../update-responsive-values';

/**
 * Update a single property for a specific breakpoint
 */
export const updateResponsiveProperty = < T, K extends keyof T >(
	attributes: ResponsiveAttributes< T >,
	property: K,
	value: T[ K ],
	breakpoint: ResponsiveBreakpoint,
): Partial< ResponsiveAttributes< T > > => {
	return updateResponsiveValues(
		attributes,
		{ [ property ]: value } as unknown as Partial< T >,
		breakpoint,
	);
};
